import { t } from "i18next";

import { CategoryStyles } from "@/config";
import { ChartDataPoint, ReviewCategory } from "@/types";

import { ascendingSort, descendingSort } from "./misc";

export type ChartCategory = Array<
  ChartDataPoint & { children: Array<ChartDataPoint> }
>;

export function formatCategoriesForPieCharts(
  categories: Array<ReviewCategory>
): ChartCategory {
  return categories.map((category) => {
    const categoryConfig = CategoryStyles[category.key];
    return {
      name: t(`reviewCategories:${category.key}`),
      value: Number(category.carbon),
      color: categoryConfig?.color,
      children: category.children
        .sort((a, b) => descendingSort(Number(a.carbon), Number(b.carbon)))
        .map((child) => ({
          name: t(`reviewCategories:${child.key}`),
          value: Number(child.carbon),
          color: categoryConfig?.subcategoryColors?.[child.key] ?? "",
        })),
    };
  });
}

export function sortDotDecimalStrings(
  dotDecimalStrings: Array<string>,
  order: "asc" | "desc" = "asc"
): Array<string> {
  if (order === "asc")
    return dotDecimalStrings.sort((a, b) =>
      ascendingSort(Number(a), Number(b))
    );
  return dotDecimalStrings.sort((a, b) => descendingSort(Number(a), Number(b)));
}
